import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { EPaymentMethodGranular } from "../../getContent/constants";
import { State } from "../../getState/State";
import { submitPayment } from "../../submitPayment/dev";
import { produce } from "../../../../libs/immer";
import { wait } from "../../../../utils/fn";
import { EPaymentStatusConstant } from "../constants";
import { sessionStateMap } from "../persistence/map.dev";
import { clearParams } from "../utils";
export var cardLoginStrategy = {
  predicate: function predicate(params) {
    return Object.keys(params).includes(EPaymentStatusConstant.ContinuePaymentParameter);
  },
  request: function () {
    var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params, content, setState) {
      var _sessionStateMap$save;
      var sum;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            clearParams([EPaymentStatusConstant.ContinuePaymentParameter]);
            sum = (_sessionStateMap$save = sessionStateMap.saveSum) === null || _sessionStateMap$save === void 0 ? void 0 : _sessionStateMap$save.load();
            setState(produce(function (draft) {
              draft.isOpen = true;
              draft.sumInput.value = sum !== null && sum !== void 0 ? sum : '';
              draft.selectedPaymentId = EPaymentMethodGranular.Card;
            }));
            _context.next = 5;
            return wait(0);
          case 5:
            return _context.abrupt("return", submitPayment(function () {
              return State.getInstance().getData();
            }, setState));
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function request(_x, _x2, _x3) {
      return _request.apply(this, arguments);
    }
    return request;
  }()
};